import { Card, Grid, SxProps, Theme } from '@mui/material';
// import { useState } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';

import { useIsMediaQuery } from '@/shared';
// import { PDFControlPanel } from '..';

export interface PDFReaderProps {
  fileUrl: string;
  sxContainer?: SxProps<Theme>;
}

const PDFReader: React.FC<PDFReaderProps> = ({ fileUrl, sxContainer }) => {
  const isMobile = useIsMediaQuery('sm');
  const propsMobile = !isMobile ? { justifyContent: 'center' } : {};

  return (
    <>
      {fileUrl ? (
        <Grid item xs={12} sx={sxContainer}>
          <Grid
            item
            container
            xs={12}
            sx={{
              width: '100%',
              minWidth: '100%',
              overflowX: 'scroll',
              scrollBehavior: 'auto',
            }}
            {...propsMobile}
          >
            <iframe
              src={`${fileUrl}`}
              width={"100%"}
              height={"500px"}
            />
          </Grid>
        </Grid>
      ) : (
        <Card
          sx={{
            p: 2,
            mt: 6,
            textAlign: 'center',
            width: '50%',
          }}
        >
          No se encontró el documento.
        </Card>
      )}
    </>
  );
};

export default PDFReader;